// extracted by mini-css-extract-plugin
export default {"content":"book_content__I0KIu","services":"book_services__u85Fx"};